import React from "react";
import { Chart } from "react-google-charts";

class SavedCarbon extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            chartData: [],
            elWidth: 0,
            elHeight: 0,
        };
    }

    componentDidMount() {
        this.setState({isLoading: true});

        const fetchData = () => {
            fetch("https://gigastorageinterface.ew.r.appspot.com/saved_carbon")
                .then((res) => res.json())
                .then(
                    (result) => {
                        const chartData = [["Date", "Saved Carbon compared to Gas Plant (kg)", "Saved Carbon compared to Coal Plant (kg)"]];
                        for(var i = 0; i < result.length; i++){
                            var data_object = result[i];
                            chartData.push([
                                new Date(data_object.date),
                                parseInt(data_object.saved_carbon_gas),
                                parseInt(data_object.saved_carbon_coal)
                            ]);
                        }

                        this.setState({
                            isLoading: false,
                            chartData: chartData
                        });
                    }
                );
        };

        fetchData();
        setTimeout(() => {
            fetchData();
        }, 25000000);
    }

    render() {
        if (this.state.isLoading) {
            return <div>Fetching data from API</div>
        }

        return <Chart
            width={this.state.elWidth}
            height={this.state.elHeight}
            chartType="LineChart"
            data={this.state.chartData}
            loader={this.props.loader}
            options={{
                fontName: "Poppins",
                backgroundColor: "transparent",
                strokeOpacity: 0,
                colors: this.props.colorRange,
                lineWidth: 1.5,
                legend: {
                    position: "none",
                    maxLines: 2,
                    textStyle: { color: "#fff" },
                },
                vAxis: {
                    viewWindowMode: "maximized",
                    gridlines: {
                        color: "transparent",
                    },
                    minorGridlines: {
                        color: "transparent",
                    },
                    textStyle: { color: "#fff", fontSize: "10px" },
                },
                hAxis: {
                    // viewWindowMode: "maximized",
                    slantedText: true,
                    textStyle: { color: "#fff", fontName: "Poppins", fontSize: 8 },
                    baselineColor: "#fff",
                    gridlines: {
                        color: "transparent",
                    },
                    minorGridlines: {
                        color: "transparent",
                    },
                },
                chartArea: {
                    left: "10%",
                    right: "5%",
                    top: "15%",
                    width: "90%",
                    height: "69%",
                },
                animation: {
                    duration: 1000,
                    easing: "out",
                    startup: true,
                },
            }}
        />
    }
}

export default SavedCarbon;
